import { render, staticRenderFns } from "./ProjectsManager.vue?vue&type=template&id=6021f894&scoped=true"
import script from "./projectsManager.ts?vue&type=script&lang=ts&external"
export * from "./projectsManager.ts?vue&type=script&lang=ts&external"
import style0 from "./ProjectsManager.vue?vue&type=style&index=0&id=6021f894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6021f894",
  null
  
)

export default component.exports